/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeEffects from "../../models/store/storeEffects";
import { ITaskPageOwnProps, ITaskPageStateProps, ITaskPageDispatchProps, TaskPage } from "../../components/task/TaskPage/TaskPage";
import { ITypedOption } from "../../models/common/typedOption";
import { getTaskPage, TaskThunkDispatch } from "source/models/store/task";

export function mapStateToProps(applicationState: IApplicationState, ownProps: ITaskPageOwnProps): ITaskPageStateProps {
    if (!applicationState || !applicationState.front) {
        return {
            appState: null,
            dataId: -1,
            taskPage: null,
            list: null,
            report: null
        };
    }
    const task = applicationState.task;
    return {
        appState: applicationState.session,
        dataId: task.page.dataId,
        taskPage: task.page.taskPage,
        list: task.list,
        report: task.report
    };
}

export function mapDispatchToProps(dispatch: TaskThunkDispatch): ITaskPageDispatchProps {
    return {
        onGetTaskPage: () => dispatch(getTaskPage()),
        onLogout: () => dispatch(storeEffects.logout()),
        onSetCulture: (culture: string) => dispatch(storeEffects.setCulture(culture)),
        onSaveUserParameters: (parameters: ITypedOption[]) => dispatch(storeEffects.saveUserParameters(parameters)),
        onRefreshSessionState: () => dispatch(storeEffects.refreshSessionState()),
    };
}

export default connect<ITaskPageStateProps, ITaskPageDispatchProps, ITaskPageOwnProps>(mapStateToProps, mapDispatchToProps)(TaskPage);